import { Button, styled } from '@mui/material';

export const ConfirmButton = styled(Button)({
	height: '44px',
	width: '215px',
	borderRadius: '8px',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	marginTop: '24px',
});

export const CancelButton = styled(Button)({
	height: '44px',
	width: '215px',
	borderRadius: '8px',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	marginTop: '24px',
});
